(function () {
  'use strict';

  const cfg = window.athenaCart;
  if (!cfg || !cfg.enabled || !cfg.threshold) return;

  const THRESHOLD = cfg.threshold;

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: cfg.currency || 'USD',
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function buildBar(totalCents) {
    const remaining = Math.max(0, THRESHOLD - totalCents);
    const pct = Math.min(100, Math.round((totalCents / THRESHOLD) * 100));
    const done = remaining === 0;

    const wrap = document.createElement('div');
    wrap.className = 'a-ship' + (done ? ' a-ship--done' : '');
    wrap.setAttribute('data-athena-ship', '');

    const text = document.createElement('span');
    text.className = 'a-ship__text';
    if (done) {
      text.textContent = cfg.doneText;
    } else {
      const parts = String(cfg.progressText).split(/\{\{\s*amount\s*\}\}/);
      text.appendChild(document.createTextNode(parts[0] || ''));
      const strong = document.createElement('strong');
      strong.textContent = money(remaining);
      text.appendChild(strong);
      text.appendChild(document.createTextNode(parts[1] || ''));
    }

    const track = document.createElement('span');
    track.className = 'a-ship__track';
    const fill = document.createElement('span');
    fill.className = 'a-ship__fill';
    fill.style.width = pct + '%';
    track.appendChild(fill);

    wrap.appendChild(text);
    wrap.appendChild(track);

    if (cfg.noteText) {
      const note = document.createElement('span');
      note.className = 'a-ship__note';
      note.textContent = cfg.noteText;
      wrap.appendChild(note);
    }

    wrap.setAttribute('role', 'status');
    return wrap;
  }


  function mountPoints() {
    return [
      document.querySelector('cart-drawer .drawer__inner-empty') ? null : document.querySelector('cart-drawer .drawer__contents'),
      document.querySelector('#main-cart-items'),
      // The store uses the cart notification, not a drawer, so without this the
      // bar only ever appeared once someone reached the cart page.
      document.querySelector('cart-notification .cart-notification__links'),
    ].filter(Boolean);
  }

  function render(totalCents) {
    document.querySelectorAll('[data-athena-ship]').forEach((el) => el.remove());
    if (typeof totalCents !== 'number' || totalCents <= 0) return;

    mountPoints().forEach((host) => {
      host.insertBefore(buildBar(totalCents), host.firstChild);
    });
  }

  function refresh() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (cart) render(cart.total_price);
      })
      .catch(() => {});
  }

  function start() {
    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        setTimeout(() => {
          queued = false;
          refresh();
        }, 120);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
